// extracted by mini-css-extract-plugin
export default {"heading":"App-module_heading_CPNh1e","something":"App-module_something_vHum_d","container":"App-module_container_w8XR2I"};